import { autoinject } from "aurelia-dependency-injection";
import { transient } from "aurelia-dependency-injection";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";

@autoinject
@transient()
export class OnboardingRequests {

    public canTakeOwnership: boolean;
    public canReassign: boolean;

    public constructor(private workflowAssignmentsService: WorkflowAssignmentsService,
        private dialogClientService: DialogClientService,
        private notificationService: NotificationClientService) { }

    public model: any;

    public activate(model: any) {
        this.model = model;
        const item = this.model.selectedItem;
        if (item) {
            const workflowStateId = item.workflowStateId;
            if (item.workflowStateId) {
                this.workflowAssignmentsService.getWorkflowState(null, null, item.workflowStateId).then(x => {
                    if (workflowStateId == x.workflowState.workflowStateId) {
                        this.canTakeOwnership = x.canTakeOwnership;
                        this.canReassign = x.canReassign;
                    }
                }).catch(() => {
                    this.canTakeOwnership = false;
                    this.canReassign = false;
                });
            }
        } else {
            this.canTakeOwnership = false;
            this.canReassign = false;
        }
    }

    takeOwnership() {
        return new Promise<void>((resolve, reject) => {
            this.workflowAssignmentsService.takeOwnership(this.model.selectedItem.currentWorkflowAssignmentId).then(x => {
                resolve();
                if (x.workflowState != null) {
                    this.notificationService.show("On Boarding Workflow", "You are now the owner of this workflow", NotificationType.Info);
                }
            }).catch(x => {
                reject(x);
                this.notificationService.show("On Boarding Workflow", "Error taking ownership!", NotificationType.Error);
            });
        });
    }

    reassign() {
        this.dialogClientService.show(DialogServiceConstants.URLs.ReassignWorkflowDialog,
            {
                id: this.model.selectedItem.currentWorkflowAssignmentId,
                reloadData: this.model.datagrid.reloadData
            });
    }
}
